import React from 'react';
import { PopUpInputsGroup } from '../pop-up-inputs-group';
import { AboutHash } from '../aboutHashComp/aboutHash';
import { FairnessFormGroup } from '@pascal/pascal-core/table-line/table-containers/fairnessFormGroup';

export const FairnessPopup = () =>{
  return (
      <div className="lotto-game-fairness">
        <AboutHash/>
        <FairnessFormGroup />
        {/*<PopUpInputsGroup/>*/}
      </div>
  )};
